const CURRENCY_TOKEN_REGEX = /([+-]?)\$(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)/g;

export const roundCurrencyAmountsInText = (text: string): string => {
  return text.replace(CURRENCY_TOKEN_REGEX, (_match, sign: string, amount: string) => {
    const numericAmount = Number(amount.replace(/,/g, ''));

    if (Number.isNaN(numericAmount)) {
      return `${sign}$${amount}`;
    }

    const roundedAmount = Math.round(numericAmount);
    const formattedAmount = roundedAmount.toLocaleString('en-US');

    return `${sign}$${formattedAmount}`;
  });
};
